<template>
  <v-container>
    <v-container>
      <v-card tile>
        <div class="d-sm-flex justify-space-between">
          <v-card-title style="margin-bottom: 20px; display: inline-block">
            {{ $t("transactionsTitle") }}
            <div
              style="display: inline-block"
              v-if="
                checkPermission('accounts.anvio.transactions.edit') &&
                checkPermission('accounts.anvio.transactions.all')
              "
            >
              <v-btn icon @click.stop="showTransactionsModal = true">
                <v-icon>mdi-plus-circle</v-icon>
              </v-btn>
              <transactions-modal
                :transactionsModal="showTransactionsModal"
                :transactionTypes="transactionTypes"
                :selectedLocation="
                  selectedFilters.location[0] ? selectedFilters.location[0] : null
                "
                :isRefund="isRefund"
                :refundItem="refundItem"
                @reload-transactions="uploadTransactions"
                @close-dialog="closeTransactionsModal"
              ></transactions-modal>
            </div>
          </v-card-title>
          <v-card-title v-if="location.allow_refill" style="margin-bottom: 20px; display: inline-block">
            {{ $t("transactionsAccountTopUp") }}
            <div style="display: inline-block">
              <v-btn icon @click.stop="showTransactionsAccountModal = true">
                <v-icon>mdi-plus-circle</v-icon>
              </v-btn>
              <transactions-account-modal
                :transactionsModal="showTransactionsAccountModal"
                :selectedLocation="
                  selectedFilters.location[0] ? selectedFilters.location[0] : null
                "
                @reload-transactions="uploadTransactions"
                @close-dialog="showTransactionsAccountModal = false"
              ></transactions-account-modal>
            </div>
          </v-card-title>
        </div>
        <v-container class="py-0 px-3">
          <v-row>
            <v-col cols="12" sm="2" class="py-0">
              <v-menu
                v-model="datepickerStart"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="
                      moment(selectedFilters.date_start).format('DD.MM.YYYY')
                    "
                    :label="$t('transactionsOperationStart')"
                    type="text"
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    prepend-icon="mdi-calendar-start"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :max="moment().format('YYYY-MM-DD')"
                  v-model="selectedFilters.date_start"
                  no-title
                  scrollable
                  :locale="$i18n.locale"
                  @change="uploadTransactions()"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="2" class="py-0">
              <v-menu
                v-model="datepickerEnd"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="
                      moment(selectedFilters.date_end).format('DD.MM.YYYY')
                    "
                    :label="$t('transactionsOperationEnd')"
                    type="text"
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    prepend-icon="mdi-calendar-end"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :min="moment(selectedFilters.date_start).format('YYYY-MM-DD')"
                  :max="moment().format('YYYY-MM-DD')"
                  v-model="selectedFilters.date_end"
                  no-title
                  scrollable
                  :locale="$i18n.locale"
                  @change="uploadTransactions"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="2" class="py-0">
              <v-select
                item-text="name"
                item-value="id"
                prepend-icon="mdi-map-marker-multiple-outline"
                dense
                :label="$t('transactionsLocations')"
                :items="locationsConcise"
                v-model="computedLocation"
                @change="uploadTransactions"
                multiple
              >
                <template slot="no-data">
                  <span class="grey--text caption ml-1">{{
                    $t("placeholderLoading")
                  }}</span>
                </template>
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ item.name }}</span>
                  <span v-if="index === 1" class="grey--text caption ml-1"
                    >(+{{ selectedFilters.location.length - 1 }})</span
                  >
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" sm="2" class="py-0">
              <v-select
                item-text="text"
                item-value="transaction_type"
                prepend-icon="mdi-filter-outline"
                dense
                :label="$t('transactionsTypeGeneral')"
                :items="transactionFilter"
                v-model="selectedTransactionFilterType"
                @change="changeTransactionTypeFilter"
              >
                <template slot="no-data">
                  <span class="grey--text caption ml-1">{{
                    $t("placeholderLoading")
                  }}</span>
                </template>
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ item.text }}</span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" sm="2" class="py-0">
              <v-select
                  item-text="text"
                  item-value="value"
                  prepend-icon="mdi-filter-outline"
                  dense
                  :label="$t('transactionsType')"
                  :items="transactionTypesFilter"
                  v-model="selectedTransactionFilterKind"
                  @change="changeTransactionTypeFilter"
              >
                <template slot="no-data">
                  <span class="grey--text caption ml-1">{{
                      $t("placeholderLoading")
                    }}</span>
                </template>
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ item.text }}</span>
                </template>
              </v-select>
            </v-col>
<!--            <v-col cols="12" sm="3" class="py-0">-->
<!--              <div class="d-flex justify-space-between">-->
<!--                <div class="d-flex flex-column">-->
<!--                  <div>-->
<!--                    <span>{{ $t("transactionsTotalWithdrawal") + ": " }}</span-->
<!--                    ><span class="red&#45;&#45;text">{{ sessionAmount }}</span>-->
<!--                  </div>-->
<!--                  <div>-->
<!--                    <span>{{ $t("transactionsTotalSessions") + ": " }}</span-->
<!--                    ><span class="red&#45;&#45;text">{{ sessionCount }}</span>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <v-btn-->
<!--                  @click="calcTransactions"-->
<!--                  outlined-->
<!--                  color="blue darken-1"-->
<!--                  text-->
<!--                  >{{ $t("transactionsCalculate") }}-->
<!--                </v-btn>-->
<!--              </div>-->
<!--            </v-col>-->
            <v-col class="py-0 col-auto ml-auto">
              <v-btn
                @click="uploadTransactions('csv')"
                outlined
                color="green darken-1"
                text
                tile
                :loading="loadingCSV"
                :disabled="
                  transactions == null || transactions == [] || loadingCSV
                "
              >
                <v-icon left>mdi-file-export</v-icon>
                CSV
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <v-container>
          <v-data-table
            v-if="transactions"
            :headers="headers"
            :items="transactions"
            :items-per-page="20"
            class="elevation-1"
            :no-data-text="$t('transactionsNoData')"
            :footer-props="{
              'items-per-page-options': limits,
              'items-per-page-text': $t('transactionsRowsPerPage'),
            }"
            :server-items-length="totalPages"
            :page.sync="currentPage"
            :items-per-page.sync="selectedLimit"
            @update:page="onPageUpdate"
            @update:items-per-page="onItemsPerPageUpdate"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
          >
            <template v-slot:item.operation_dt="{ item }">
              <span>{{ item.operation_dt | dateFilter }}</span>
            </template>
            <template v-slot:item.total="{ item }">
              <span
                v-html="
                  item.total +
                  ' ' +
                  (item.currency && item.currency.unicode
                    ? item.currency.unicode
                    : '')
                "
              ></span>
            </template>
            <template v-slot:item.amount="{ item }">
              <strong
                :class="[
                  { 'red--text': item.amount < 0 },
                  { 'green--text': item.amount > 0 },
                ]"
                v-html="
                  item.amount +
                  ' ' +
                  (item.currency && item.currency.unicode
                    ? item.currency.unicode
                    : '')
                "
              ></strong>
            </template>
            <template v-slot:item.additional="{ item }">
              <span v-if="item.additional">{{ $t("btnYes") }}</span>
              <span v-else>{{ $t("btnNo") }}</span>
            </template>
            <template v-slot:item.type="{ item }">
              <div class="d-flex justify-space-between align-center">
                <div>
                  <span v-if="item.type">
                    {{ $t(`transactionsTypes.${item.type}`) || item.type }}
                  </span>
                  <span v-else class="text--disabled">
                    {{ $t('transactionsTypes.noType') }}
                  </span>
                </div>
                <div v-if="
                  checkPermission('accounts.anvio.transactions.edit') &&
                  checkPermission('accounts.anvio.transactions.all')"
                >
                  <v-menu offset-y>
                    <template #activator="{ on, attrs }">
                      <v-icon small class="ml-2" v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
                    </template>
                    <v-list dense>
                      <v-list-item @click="openTypeEditDialog(item)">
                        <v-list-item-icon class="mr-3">
                          <v-icon small>mdi-pencil</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t('transactionsActions.editType') }}</v-list-item-title>
                      </v-list-item>

                      <v-list-item @click="handleRefund(item)">
                        <v-list-item-icon class="mr-3">
                          <v-icon small>mdi-undo</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t('transactionsActions.refund') }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </div>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                icon
                @click.stop="
                  (contestForm = true), (selectedTransaction = item.id)
                "
              >
                <v-icon>mdi-file-cancel-outline</v-icon>
              </v-btn>
            </template>
            <template v-slot:top>
              <v-dialog v-model="contestForm" persistent width="500">
                <v-card tile>
                  <v-card-title class="headline">{{
                    $t("contestFormTitle")
                  }}</v-card-title>
                  <v-card-text>
                    <v-textarea
                      :label="$t('contestFormDescription') + '*'"
                      dense
                      v-model="evidence.text"
                      rows="1"
                      auto-grow
                      class="mt-4"
                    ></v-textarea>
                    <v-file-input
                      v-model="evidence.files"
                      counter
                      :label="$t('contestFormFiles')"
                      multiple
                      :placeholder="$t('contestFormFilesUpload')"
                      append-icon="mdi-paperclip"
                      prepend-icon=""
                      :show-size="1000"
                      class="file-input"
                    >
                      <template v-slot:selection="{ index, text }">
                        <v-chip v-if="index < 2" dark label small
                          >{{ text }}
                        </v-chip>
                        <span v-else-if="index === 2" class="overline mx-2"
                          >+{{ files.length - 2 }} File(s)</span
                        >
                      </template>
                    </v-file-input>
                    <small>* {{ $t("validation") }}</small>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="red darken-1"
                      text
                      @click.stop="contestForm = false"
                      >{{ $t("btnCancel") }}</v-btn
                    >
                    <v-btn
                      color="green darken-1"
                      text
                      @click="submitForm()"
                      :disabled="$v.evidence.$invalid"
                    >
                      {{ $t("btnSend") }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
          </v-data-table>
          <v-skeleton-loader
            v-else
            class="mx-n3 mt-n4"
            type="table-thead, table-tbody, table-tfoot"
            tile
          ></v-skeleton-loader>
        </v-container>
      </v-card>

      <v-dialog v-model="confirmDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">{{ $t("transactionsChangeType") }}</v-card-title>
          <v-card-text>
            <v-select
                :items="transactionTypes"
                v-model="selectedType"
                item-text="text"
                item-value="value"
                dense
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="cancelTypeChange">{{ $t("btnExit") }}</v-btn>
            <v-btn color="green darken-1" text @click="confirmTypeChange">{{ $t("btnApply") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-container>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import store from "../../store";
import TransactionsModal from "@/components/TransactionsModal.vue";
import TransactionsAccountModal from "@/components/TransactionsAccountModal.vue";

export default {
  name: "Transactions",

  beforeRouteEnter: async (to, from, next) => {
    await store.dispatch("loadLocation", to.params.location_id);
    next();
  },

  components: {
    TransactionsModal,
    TransactionsAccountModal,
  },

  mixins: [validationMixin],

  data() {
    return {
      fakeProp: 6,
      showTransactionsModal: false,
      showTransactionsAccountModal: false,
      sessionAmount: null,
      sessionCount: null,
      loadingCSV: false,
      datepickerStart: false,
      datepickerEnd: false,
      contestForm: false,
      transactions: null,
      transactionsCSV: null,
      sortBy: "operation_dt",
      sortDesc: true,
      headers: [
        {
          text: this.$i18n.t("transactionsSession"),
          value: "session",
          width: "10%",
          sortable: false,
        },
        {
          text: this.$i18n.t("transactionsDate"),
          value: "operation_dt",
          width: "10%",
          sortable: false,
        },
        {
          text: this.$i18n.t("transactionsDescription"),
          value: "description",
          width: "10%",
          sortable: false,
        },
        {
          text: this.$i18n.t("transactionsAmount"),
          value: "amount",
          width: "8%",
          sortable: false,
        },
        {
          text: this.$i18n.t("transactionsAdditional"),
          value: "additional",
          width: "5%",
          sortable: false,
        },
        {
          text: this.$i18n.t("transactionsBalance"),
          value: "total",
          width: "10%",
          sortable: false,
        },
        {
          text: this.$i18n.t("transactionsLicense"),
          value: "license",
          width: "10%",
          sortable: false,
        },
        {
          text: this.$i18n.t("transactionsCode"),
          value: "code",
          width: "10%",
          sortable: false,
        },
        {
          text: this.$i18n.t("groupType"),
          value: "type",
          width: "10%",
          sortable: false,
        },
        {
          text: this.$i18n.t("transactionsUser"),
          value: "user_email",
          width: "5%",
          sortable: false,
        },
        {
          text: "",
          value: "actions",
          align: "end",
          width: "5%",
          sortable: false,
        },
      ],
      selectedFilters: {
        date_start: moment().startOf("month").format("YYYY-MM-DD"),
        date_end: moment().format("YYYY-MM-DD"),
        location: [],
        transaction_type: "",
      },
      transactionFilter: [
        { text: this.$i18n.t("transactionsTypeAll"), transaction_type: "all" },
        { text: this.$i18n.t("transactionsTypeIn"), transaction_type: "in" },
        { text: this.$i18n.t("transactionsTypeOut"), transaction_type: "out" },
      ],
      transactionTypes: [
        { text: this.$i18n.t('transactionsTypes.refill'), value: 'refill',  },
        { text: this.$i18n.t('transactionsTypes.chargeoff'), value: 'chargeoff',  },
        { text: this.$i18n.t('transactionsTypes.refund'), value: 'refund',  },
        { text: this.$i18n.t('transactionsTypes.overdraft'), value: 'overdraft',  },
        { text: this.$i18n.t('transactionsTypes.minimumfee'), value: 'minimumfee',  },
        { text: this.$i18n.t('transactionsTypes.vatfee'), value: 'vatfee',  }
      ],
      confirmDialog: false,
      selectedType: null,
      selectedTypeId: null,
      refundItem: null,
      isRefund: false,
      selectedTransactionFilterType: "all",
      selectedTransactionFilterKind: "",
      selectedTransaction: null,
      totalPages: null,
      selectedLimit: 10,
      limits: [10, 15, 30, 50, 100],
      currentPage: 1,
      evidence: {
        text: "",
        files: [],
      },
    };
  },

  mounted() {
    this.selectedFilters.location = [this.locationId];
    this.uploadTransactions();
  },

  validations: {
    evidence: {
      text: {
        required,
      },
    },
  },

  computed: {
    ...mapGetters(["checkPermission", "locationsConcise", "locationId", "location"]),
    computedLocation: {
      get: function () {
        const locationArr = [];
        if (typeof this.selectedFilters.location == "object") {
          this.selectedFilters.location = Array.from(
            this.selectedFilters.location
          ).map((i) => Number(i));
        } else if (this.selectedFilters.location) {
          locationArr.push(Number(this.selectedFilters.location));
          this.selectedFilters.location = locationArr;
        }
        return this.selectedFilters.location;
      },
      set: function (value) {
        this.selectedFilters.location = value;
      },
    },
    textErrors() {
      const errors = [];
      if (!this.$v.evidence.text.$dirty) return errors;
      !this.$v.evidence.text.required &&
        errors.push(this.$i18n.t("validationRequired"));
      return errors;
    },
    transactionTypesFilter() {
      return [
        { text: this.$i18n.t("transactionsTypeAll"), value: "" },
        ...this.transactionTypes
      ]
    }
  },

  filters: {
    dateFilter(value) {
      return moment(value).format("DD.MM.YYYY HH:mm");
    },
  },

  methods: {
    ...mapActions(["getTransactions", "setDispute", "loadLocationsConcise"]),
    loadTransactions(payload) {
      if (this.selectedFilters.location.length) {
        this.transactions = null;
        this.sessionAmount = null;
        this.sessionCount = null;
        this.getTransactions(payload).then((response) => {
          if (response.data.results) {
            this.transactions = response.data.results;
            this.totalPages = response.data.count;
          } else {
            this.transactions = [];
          }
        });
      }
    },
    uploadTransactions(format) {
      this.selectedFilters.transaction_type = this.selectedTransactionFilterType;
      this.selectedFilters.transaction_kind = this.selectedTransactionFilterKind;
      this.selectedFilters.offset = this.selectedLimit * (this.currentPage - 1);
      this.selectedFilters.limit = this.selectedLimit;
      const filteredFilters = Object.entries(this.selectedFilters).reduce(
        (a, [k, v]) =>
          typeof v === "object" && !v.length ? a : ((a[k] = v), a),
        {}
      );
      let payload = Object.keys(filteredFilters)
        .map((key) => key + "=" + filteredFilters[key])
        .join("&");

      if (format && format == "csv") {
        this.loadingCSV = true;
        payload = payload + "&format=csv";
        this.getTransactions(payload).then((response) => {
          if (response.data) {
            this.transactionsCSV = response.data;
            this.loadingCSV = false;
            this.downloadCSV();
          } else {
            this.transactionsCSV = null;
          }
        });
      } else {
        this.loadTransactions(payload);
      }
    },
    calcTransactions() {
      const transactions = this.transactions.filter((t) => t.session);
      this.sessionAmount = transactions.reduce(
        (prev, curr) => (prev += parseFloat(curr.amount)),
        0
      );
      this.sessionCount = transactions.length;
    },
    downloadCSV() {
      const anchor = document.createElement("a");
      anchor.href =
        "data:text/csv;charset=utf-8," +
        encodeURIComponent(this.transactionsCSV);
      anchor.target = "_blank";
      anchor.download = "transactions.csv";
      anchor.click();
    },
    submitForm() {
      let formData = new FormData();
      formData.append("text", this.evidence.text);
      if (this.evidence.files) {
        this.evidence.files.forEach((file, index) => {
          formData.append("files", file, file.name);
        });
      }

      this.setDispute({ id: this.selectedTransaction, data: formData }).then(
        (response) => {
          this.contestForm = false;
          store.commit("alerts", this.$i18n.t("transactionsAlert"));
          setTimeout(() => {
            store.commit("alerts", null);
          }, 8000);
        }
      );
    },
    changeTransactionTypeFilter() {
      this.currentPage = 1;
      this.uploadTransactions();
    },
    onPageUpdate(newPage) {
      this.currentPage = newPage;
      this.uploadTransactions();
    },
    onItemsPerPageUpdate(newLimit) {
      this.selectedLimit = newLimit;
      this.uploadTransactions();
    },
    openTypeEditDialog(item) {
      this.selectedType = item.type;
      this.selectedTypeId = item.id;
      this.confirmDialog = true;
    },
    cancelTypeChange() {
      this.confirmDialog = false;
      this.selectedType = null;
      this.selectedTypeId = null;
    },
    confirmTypeChange() {
      this.handleTypeChange();
      this.confirmDialog = false;
      this.selectedType = null;
      this.selectedTypeId = null;
    },
    async handleTypeChange() {
      await this.$store.dispatch('changeTransactionType', {
        payload: { type: this.selectedType, transaction_id: this.selectedTypeId },
        i18n: this.$i18n
      });
      this.uploadTransactions();
    },
    handleRefund(item) {
      this.refundItem = item;
      this.isRefund = true;
      this.showTransactionsModal = true;
    },
    closeTransactionsModal() {
      this.isRefund = false;
      this.showTransactionsModal = false
    }
  },

  created() {
    this.loadLocationsConcise();
  },

  watch: {
    contestForm(visible) {
      if (!visible) {
        this.evidence.text = null;
        this.evidence.files = [];
        this.$v.evidence.$reset();
      }
    },
  },
};
</script>

<style>
.file-input.v-text-field > .v-input__control > .v-input__slot {
  cursor: pointer;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
